module.exports = __webpack_public_path__ + "img/hgsHgcHgh.ae50cc40.png";